/* eslint-disable import/prefer-default-export */

export const TABLE_DATA_CHANGED = "TABLE_DATA_CHANGED";
export const IS_LOADING_TABLE_DATA_CHANGED = "IS_LOADING_TABLE_DATA_CHANGED";
export const SELECTED_DATA_CHANGED = "SELECTED_DATA_CHANGED";
